import SEO from './SEO';
import { buildUrl } from '../../config/seo';
import { getPricingPlans } from '../../data/pricingPlans';

const MockInterviewSEO = () => {
  const pricingPlans = getPricingPlans();

  return (
    <SEO
        title="Mock Interview Service - Practice with Expert Interviewers"
        description="Practice web developer interviews with experienced interviewers. Get detailed feedback, performance analytics, and flexible scheduling. Choose from single session or bundle packages."
        keywords="mock interview, technical interview practice, coding interview preparation, interview feedback, developer interview coaching, interview simulation"
        url={buildUrl('/mock-interview')}
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Mock Interview Service",
          "description": "Professional mock interview service for web developers",
          "provider": {
            "@type": "Organization",
            "name": "The Web Dev Interview"
          },
          "offers": pricingPlans.map(plan => ({
            "@type": "Offer",
            "name": plan.title,
            "price": plan.price,
            "priceCurrency": "USD",
            "description": plan.subtitle
          }))
        }}
      />
  );
};

export default MockInterviewSEO;